import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { COLORS } from '../styles/colors';
import Modal from '@material-ui/core/Modal';
import ModalHeading from './ModalHeading';
import { EditInstruction } from '../containers/Instructions';
export default class EditInstructionButton extends Component {

	state = {
		open: false
	};

	render() {

    const { instruction } = this.props;
    const { open } = this.state;
		return (
			<div>
	    	<Modal
	        className="modal show"
	        open={open}
	        onClose={() => this.setState({open:false})}>
	        <div className="modalBody modal-content" style={{width:1050, maxHeight: '90%', overflow: 'auto'}}>
						<ModalHeading
							text={(
								<div>
									<FontAwesomeIcon icon="edit"
										style={{marginRight: 5, color: COLORS.orange}}/>
									<span>{instruction.name}</span>
								</div>

							)}
							closeModal={() => this.setState({...this.state, open: false})}/>
						<div className="modalContent">
							<EditInstruction editId={instruction._id} hideNavigationTabs={true} onClose={() => this.setState({ open: false })}  />
						</div>
	        </div>
	      </Modal>
		    <span
          className="link"
          onClick={() => this.setState({open:true})}
          style={{float:'right'}}>
          <FontAwesomeIcon icon="edit" title={'Edit'}
            style={{marginRight: 5, color: COLORS.orange}}/>
        </span>
			</div>
    );
	}
}



// WEBPACK FOOTER //
// ./src/components/EditInstructionButton.js